let pageSize = 10;
export default pageSize;



// WEBPACK FOOTER //
// ./src/store/global.js